import { Component, OnInit } from '@angular/core';
// import { FlattenMatchMigration } from "../../../migrations";
// import { StandardizedServicesMigration } from "../../../migrations";

@Component({
  selector: 'migration-runner',
  template: '',
  styles: []
})
export class MigrationRunner implements OnInit {
  constructor() {}

  ngOnInit(): void {
    // this.migration.migrate();
  }
}
